export const templateGroup = {
    type: 'templateGroup',
    showExpanded: true,
    templateGroup: {
        showOuterChoose: false,
        showCheckedCon: true,
        industry: {
            value: ''
        },
        sizeControl: {
            value: {
                ratio: '16:9',
                dimension: '1140*640',
                customWidth: '',
                customHeight: ''
            }
        },
        template: {
            activeTab: 'commonTemplate',
            chooseList: [],
            chooseMyTpl: []
        }
    }
};

export const defaultFormData = {
    templateGroup,
    textBatchGroup: {
        type: 'textBatchGroup',
        showExpanded: false,
        textBatchGroup: {}
    },
    imageBatchGroup: {
        type: 'imageBatchGroup',
        showExpanded: true,
        imageBatchGroup: {}
    }
};